import { coreService } from '../../../service/core-service'
import { errorUtil } from '../../../util/auth-error-util'
import { logger } from '../../../util/logger'
import { LoadingSpinner } from '../util/spinner/loading-spinner'
import React, { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

export const PrivacyPolicy = (): React.ReactElement => {
  const [privacyPolicy, setPrivacyPolicy] = useState<string>()
  useEffect(() => {
    coreService
      .getLegalPrivacyPolicy()
      .then((result) => setPrivacyPolicy(result))
      .catch((err) => errorUtil.logError(err))
  })
  return (
    <LoadingSpinner isLoading={!privacyPolicy}>
      <ReactMarkdown
        className={'markdown-table'}
        remarkPlugins={[remarkGfm]}
        transformLinkUri={(src: string): string => {
          if (src[0] === '#') return window.location.pathname + src
          return src
        }}
      >
        {privacyPolicy!}
      </ReactMarkdown>
    </LoadingSpinner>
  )
}
